import React from "react";
import PageHeader from "../../shared/components/PageHeader";

// Page-header definition for the legacy v1 Social Development page. The grade-band
// menu becomes the header tabs; the term picker sits beside the title like every
// other page. Two things differ from the other migrated pages and are deliberate:
//   - The tabs drive local `level` state (not navigation), so they call
//     onLevelChange; v1 keeps syncing `?level=` and refetching.
//   - The term selector has no auto-default: this page starts with no term and
//     shows a "select a term" prompt until one is picked, so "Select Term" is a
//     real, selectable value (allowEmpty, onChange(null)), not just a placeholder.
export default function SocialDevelopmentHeader({
  levels = [],
  activeLevel,
  onLevelChange,
  terms = [],
  selectedTermId,
  onTermChange,
}) {
  return (
    <PageHeader
      title="Social Development/Work Ethic"
      termSelector={{
        terms,
        value: selectedTermId,
        onChange: onTermChange,
        allowEmpty: true,
        emptyLabel: "Select Term",
      }}
      // The tabs drive local `level` state, not navigation: each selects its
      // grade band through onLevelChange (v1 keeps syncing `?level=`).
      tabs={levels.map((lvl) => ({
        key: lvl,
        label: lvl,
        onClick: () => onLevelChange(lvl),
      }))}
      activeTab={activeLevel}
    />
  );
}
